import { clientsEpic as epic } from './epic'
import { clientsReducer as reducer } from './reducer'

export const clientsEpic = epic
export const clientsReducer = reducer
